export enum CONTACT_FORM_NAME {
    CHANGE_REQUEST = 'change request',
    CHANGE_REQUEST_FROM_GUARD = 'change request from guard',
    PROFILE_EDIT_REQUEST_FROM_GUARD = 'profile edit request from guard',
    REPORT_AN_ISSUE = 'report an issue',
    REPORT_AN_ISSUE_FROM_GUARD = 'report an issue from guard',
    SPECIAL_REQUEST = 'special request'
}
